import type { JSX } from 'react';
import React from 'react';
import { IconClock } from '@tabler/icons-react';
import { CalendarClock } from 'lucide-react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@core-ui/Components/ui/card';

export default function ScheduleSessionPage (): JSX.Element {
  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-6 bg-[var(--layout-schedule)]">
      <Card className="h-[95dvh] w-full max-w-[97.5dvw] py-0 border-0.5 border-[var(--color-black)] overflow-hidden rounded-2xl bg-[var(--layout-schedule)]">

        <CardHeader className="h-[15%] w-full flex flex-col border-b-0.5 shadow-[0_2px_4px_-2px_rgba(0,0,0,0.25)] border-[var(--color-black)] rounded-t-2xl px-0 gap-0">
          <div className="h-[15%] min-h-[8px] w-full bg-[var(--line-schedule)] rounded-t-2xl"></div>
          <div className="flex flex-row items-center justify-between w-full px-4 flex-1">
            <div className="flex items-center space-x-3">
              <CalendarClock className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-[var(--icon-text-schedule)] bg-[var(--icon-bg-schedule)] rounded-3xl p-2 sm:p-2.5 md:p-3" />
              <div className="text-left flex flex-col justify-center space-y-1">
                <CardTitle className="text-lg sm:text-xl md:text-2xl text-[var(--color-black)] font-bold leading-tight m-0">
                          Tendril Connect Session
                </CardTitle>
                <CardDescription className="text-xs sm:text-sm md:text-base text-[var(--color-black)] leading-tight m-0">Pick a date & time that works for you.</CardDescription>
              </div>
            </div>
              
            <div className="flex items-center space-x-2 text-[var(--color-black)] ">
              <IconClock size={18} />
              <p className="text-xs sm:text-sm md:text-base">1 hr</p>
            </div>
          </div>
        </CardHeader>

        <CardContent className="h-[85%] max-h-[85vh] flex items-center justify-center p-0 overflow-auto lg:overflow-visible">
          <iframe
            src="https://calendly.com/pod-leaders/tendril-connect-session"
            className="w-full h-[97%]"
          />
        </CardContent>

        <CardFooter className="flex flex-col sm:flex-row sm:justify-between py-4 text-[var(--color-black)] gap-2 text-center sm:text-left">
          <p className="text-xs sm:text-sm md:text-base">
                        Trouble loading?{' '}
            <a
              href="https://calendly.com/pod-leaders/tendril-connect-session"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--line-schedule)] underline"
            >
                            Open in new tab.
            </a>
          </p>
          <p className="text-xs sm:text-sm md:text-base">Times auto-adjust to your device time zone.</p>
        </CardFooter>
      </Card>
    </div>
  );
}